import { getRelativeImagePath } from "./getRelativeImagePath";

export function getProductImage(imageObj, isOriginalImage?: boolean, imagePreload?: string) {
  const imageURL = "https://partsavatar.ca/images/common/image-not-available_16051144.png";
  const imagePathPrefix = isOriginalImage ? "large-product-images" : process.env.NEXT_PUBLIC_PRODUCT_IMAGE_PATH;
  if (typeof imageObj === "undefined") {
    return imageURL;
  }
  if (typeof imageObj === "string") {
    return imagePreload ? getRelativeImagePath(`/img/${imagePreload}/${imageObj}`) : getRelativeImagePath(`/${imagePathPrefix}/${imageObj}`);
  }
  if (imageObj && imageObj.type === "a") {
    return imageObj.url;
  }
  if (imageObj && imageObj.type === "r") {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}/${imagePathPrefix}/${imageObj.url}`;
  }
  return imageURL;
}
